import styled, { css } from 'styled-components';

import { mediaQuery } from '../../styles/mixin';

export const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    ${mediaQuery(
        2,
        css`
            padding: 1rem 2.375rem 2rem 4.125rem;
            width: 100%;
            height: 100%;
        `
    )}
`;
